import React from 'react';
import { connect } from 'react-redux';
import { MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { createActions } from '../../store';
import CheckIcon from '@mui/icons-material/CheckRounded';
import { ASSET_UPLOADING_MODE } from '../../CreatePageConstants';

const styles = theme => ({
    previewSettingMenuItemIcon: {
        minWidth: theme.spacing(5)
    },
    previewSettingMenuItemText: {
        textAlign: 'right'
    }
});

const AssetUploadingModeSelect = (props) => {
    const { classes, assetUploadingMode, setAssetUploadingMode } = props;

    const isLazy = assetUploadingMode !== ASSET_UPLOADING_MODE.DIRECT;

    return (
        <>
            <MenuItem
                onClick={() => setAssetUploadingMode(ASSET_UPLOADING_MODE.LAZY)}
                selected={isLazy}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: isLazy ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    LAZY UPLOAD
                </ListItemText>
            </MenuItem>
            <MenuItem
                onClick={() => setAssetUploadingMode(ASSET_UPLOADING_MODE.DIRECT)}
                selected={!isLazy}
            >
                <ListItemIcon className={classes.previewSettingMenuItemIcon}>
                    <CheckIcon style={{visibility: !isLazy ? null : 'hidden'}}/>
                </ListItemIcon>
                <ListItemText className={classes.previewSettingMenuItemText}>
                    DIRECT UPLOAD
                </ListItemText>
            </MenuItem>
        </>
    );
};

const mapStateToProps = (state) => {
    const { assetUploadingMode } = state.create;
    return { assetUploadingMode };
}

const mapDispatchToProps = (dispatch) => {
    const setAssetUploadingMode = (mode) => dispatch(createActions.setAssetUploadingMode(mode));
    return { setAssetUploadingMode }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(AssetUploadingModeSelect, styles));
